
import React from 'react';
import SkillsCore from '../skills/SkillsCore';

interface SkillsSectionProps {
  skillsValue: string[];
  professionValue: string;
  setSkillsValue: (skills: string[]) => void;
}

const SkillsSection: React.FC<SkillsSectionProps> = ({
  skillsValue,
  professionValue,
  setSkillsValue
}) => {
  const [newSkill, setNewSkill] = React.useState('');

  const addSkill = () => {
    if (!newSkill.trim()) return;
    if (skillsValue.includes(newSkill.trim())) return;
    
    setSkillsValue([...skillsValue, newSkill.trim()]);
    setNewSkill('');
  };

  const removeSkill = (index: number) => {
    const updatedSkills = [...skillsValue];
    updatedSkills.splice(index, 1);
    setSkillsValue(updatedSkills);
  };

  return (
    <SkillsCore
      skills={skillsValue}
      newSkill={newSkill}
      profession={professionValue}
      onNewSkillChange={setNewSkill}
      onAddSkill={addSkill}
      onRemoveSkill={removeSkill}
      showLabel={false}
    />
  );
};

export default SkillsSection;
